import React, { useEffect, useState } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config';
import useAuth from '../hooks/useAuth';

const DevMessagesModal = () => {
    const { user } = useAuth();
    const [messages, setMessages] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (!user?.uid) return;

        const fetchMessages = async () => {
            try {
                const userRef = doc(db, 'users', user.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const data = userSnap.data();
                    const unreadMessages = (data.messages || []).filter(
                        (msg) => msg.status === 'unread'
                    );

                    if (unreadMessages.length > 0) {
                        setMessages(unreadMessages);
                        setShowModal(true);
                    }
                }
            } catch (err) {
                console.error('🔥 Хабарламаларды алу қатесі:', err);
            }
        };

        fetchMessages();
    }, [user]);

    const markMessagesAsRead = async () => {
        if (!user?.uid) return;

        try {
            const userRef = doc(db, 'users', user.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                const data = userSnap.data();
                const updatedMessages = (data.messages || []).map((msg) =>
                    msg.status === 'unread' ? { ...msg, status: 'read' } : msg
                );

                await updateDoc(userRef, { messages: updatedMessages });
            }
        } catch (err) {
            console.error('🔥 Статусты жаңарту қатесі:', err);
        }
    };

    const handleClose = () => {
        markMessagesAsRead();
        setShowModal(false);
    };

    if (!showModal || messages.length === 0) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 space-y-4">
                <h2 className="text-xl font-semibold text-gray-800">📩 Жаңа хабарламалар</h2>

                <ul className="space-y-2 max-h-60 overflow-y-auto">
                    {messages.map((msg, index) => (
                        <li
                            key={index}
                            className="bg-gray-100 px-4 py-2 rounded text-gray-700 border-l-4 border-blue-500"
                        >
                            {msg.text}
                        </li>
                    ))}
                </ul>

                <div className="flex justify-between items-center pt-4">
                    <a
                        href="https://wa.me/77081056354"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-green-600 underline text-sm"
                    >
                        WhatsApp арқылы байланыс: +77081056354
                    </a>
                    <button
                        onClick={handleClose}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded shadow"
                    >
                        Жабу
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DevMessagesModal;